import { useMemo } from 'react'
import { ColumnType } from '../../containers/commons/AgGrid'
import { SequenceNoCellRenderer } from '../../containers/commons/AgGrid/components/cell/custom/sequenceNo/SequenceNoCellRenderer'
import { BulkSheetProperty } from './bulksheetProperty'
import { IRowNode } from 'ag-grid-community'

export const useRowNumber = (): BulkSheetProperty => {
  const propery = useMemo(
    () => ({
      field: 'rowNumber',
      type: [ColumnType.sequenceNo],
      resizable: false,
      width: 35,
      cellRenderer: SequenceNoCellRenderer,
      cellRendererParams: params => {
        return {
          value: params.node.rowIndex + 1,
        }
      },
      comparator: (
        valueA: any,
        valueB: any,
        nodeA: IRowNode,
        nodeB: IRowNode
      ): number => (valueA ?? nodeA.rowIndex) - (valueB ?? nodeB.rowIndex),
    }),
    []
  )
  return propery
}
